import React, { useState } from 'react';
import { makeStyles, Typography, Popover as MaterialPopover, Button } from '@material-ui/core';

export default function Popover(props){
    const { id, disp, orderList, open, handleClose, anchorEl } = props
    const [index, setIndex] = useState(0)
    
    const classes = useStyles()

    const orderBy = (orderIndex) => {
        if(index===orderIndex){
            return;
        }
        setIndex(orderIndex);
        orderList(orderIndex)
    }

    return(
        <MaterialPopover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={() => handleClose()}
            PaperProps={{className:classes.popover}}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
        <Typography align="center" style={{margin:"0 0 10px 0"}}>Ordenar por</Typography>
        <Button onClick={() => orderBy(0)}
            style={{
                backgroundColor:index===0 ? "#2196C0": "transparent",
                color:index===0? "#FFF" : "#000"
            }}
        >
            Nombre
        </Button>
        <Button onClick={() => orderBy(1)}
            style={{
                backgroundColor:index===1 ? "#2196C0" : "transparent",
                color:index===1? "#FFF" : "#000"
            }}
        >
            Molecula
        </Button>
        { 
            disp && <Button onClick={() => orderBy(2)}
                style={{
                    backgroundColor:index===2 ? "#2196C0" : "transparent",
                    color:index===2? "#FFF" : "#000"
                }}
            >
                Disponible
            </Button>
        }
      </MaterialPopover>
    )
}

const useStyles = makeStyles((theme) => ({
    popover:{
        width:190,
        height:150,
        borderRadius:16,
        padding:10,
        flexDirection:"column",
        display:"flex"
    },
  }));